<div class="modal fade" [ngClass]="{ show: showFade }" [attr.aria-hidden]="!displayed" [style.display]="show ? 'block' : 'none'">
    <div [ngClass]="modalClassnames" role="document">
        <div class="modal-content w-100">
            @if (title) {
                <kui-modal-header [title]="title" (close)="close()">
                    <ng-content select="[header]"></ng-content>
                </kui-modal-header>
            }
            <kui-modal-body [hasCloseButton]="!title" (close)="close()">
                <ng-content></ng-content>
            </kui-modal-body>
            @if (actions) {
                <kui-modal-footer [actions]="actions" (buttonClicked)="handleButtonClick($event)">
                    <ng-content select="[footer]"></ng-content>
                </kui-modal-footer>
            }

            @if (loading) {
                <div class="modal-overlay d-flex flex-stretch justify-content-center align-items-center">
                    <kui-loader></kui-loader>
                </div>
            }
        </div>
    </div>
</div>
<div class="modal-backdrop fade" [ngClass]="{ show: showFade }" [style.display]="show ? 'block' : 'none'" (click)="close()"></div>
